import React from 'react';
import { MOBILE_BATTLE_DOCK_LIFT_PX } from './mobileBattleLayoutOffsets';

/**
 * Mobile Player Stats (O:, S:, C:) Component
 * Positioned at bottom-left, below the general avatar
 */
export const MobilePlayerStats = ({
  you,
  setShowStrategy,
  setShowCompletedOrders
}) => {
  return (
    <div className="player-stats-counters-mobile" style={{ 
      position: "absolute", 
      left: "5px",
      bottom: `${32 + MOBILE_BATTLE_DOCK_LIFT_PX}px`,
      zIndex: 1000,
      display: 'flex', 
      gap: "8px",
      fontSize: "9px",
      fontWeight: 'bold',
      color: 'white'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
        <span style={{ color: '#4a90e2' }}>O:</span>
        <span>{you.hand?.length || 0}</span>
      </div>
      <div 
        style={{ display: 'flex', alignItems: 'center', gap: '3px', cursor: 'pointer' }}
        onClick={() => setShowStrategy(true)}
      >
        <span style={{ color: '#4a90e2' }}>S:</span>
        <span>{you.strategy?.orders?.reduce((sum, o) => sum + (o.count || 1), 0) || 0}</span>
      </div>
      <div 
        style={{ display: 'flex', alignItems: 'center', gap: '3px', cursor: 'pointer' }}
        onClick={() => setShowCompletedOrders(true)}
      >
        <span style={{ color: '#4a90e2' }}>C:</span>
        <span>{you.completedOrders?.length || 0}</span>
      </div>
    </div>
  );
};

export default MobilePlayerStats;

